import React from 'react';
import Udesk from 'Udesk';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import { Redirect } from 'react-router-dom';

const Template = React.memo((props: any) => {
    const { routes, route, location, sdkOptions, match } = props;

    const isRedirect = (currentPath, toPath) => {
        let fullCurrentPath = Udesk.ui.routing.getRoutePath({
            routeName: currentPath.name,
            pathParams: match.params,
        });

        if (fullCurrentPath === toPath) {
            return true;
        }
        return false;
    };

    const renderSubRoutes = () => {
        const active = routes.find((route) => {
            const fullPath = Udesk.ui.routing.getRoutePath({
                routeName: route.name,
                pathParams: match.params,
            });
            return fullPath === location.pathname;
        });
        if (active) {
            return <SubRoutes route={active} />;
        } else {
            return routes.map((routeItem, i) => <SubRoutes key={i} route={routeItem} />);
        }
    };

    return (
        <React.Fragment>
            {isRedirect(route, location.pathname) ? (
                <Redirect
                    to={Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                        routeName: route.name,
                        pathParams: match.params,
                    })}
                    sdkOptions={sdkOptions}
                />
            ) : (
                <div className="case-base-pages" style={{ height: '100%' }}>
                    {renderSubRoutes()}
                </div>
            )}
        </React.Fragment>
    );
});
class Component extends React.Component {
    render() {
        return <Template {...this.props} />;
    }
}
export default Udesk.react.udeskify(Component);
